import type { ReactElement, SVGProps } from "react";
import { cn } from "@/lib/utils";

export function SkillsPageSpinnerIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      className={cn("animate-spin-1", props.className)}
    >
      <circle
        cx="8"
        cy="8"
        r="6"
        stroke="currentColor"
        strokeWidth="2"
        strokeOpacity="0.25"
      />
      <path
        d="M8 2C4.68629 2 2 4.68629 2 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
